import type { ResponseWithoutData } from "@src/types/AppTypes";
import { useCallback } from "react";
import Swal from "sweetalert2";

const useNotification = () => {
  const showNotification = useCallback((data: ResponseWithoutData) => {
    if (data.status === true && data.message) {
      Swal.fire({
        text: data.message,
        icon: "success",
        showConfirmButton: false,
        timer: data?.timer ? data.timer : 3000,
        showCloseButton: true,
        scrollbarPadding: false,
        backdrop: true, // for prevent background scroll when popup is open
      });
    } else if (data.status === false && data.message) {
      Swal.fire({
        text: data.message,
        icon: "error",
        showConfirmButton: false,
        timer: data?.timer ? data.timer : 3000,
        showCloseButton: true,
        scrollbarPadding: false,
        backdrop: true, // for prevent background scroll when popup is open
      });
    }
  }, []);
  return showNotification;
};

export default useNotification;
